import React from 'react';
import UsersList from './users-list';
import { useIsSmallScreen } from '../../system/SystemMediaQueriesProvider';

export function UsersMain() {
  const isSmall = useIsSmallScreen();

  return (
    <div
      style={{
        margin: isSmall ? '0px' : '10px 4px',
        display: 'flex',
        flexDirection: 'row',
        flex: 1,
        alignItems: 'stretch',
      }}
    >
      <UsersList />
    </div>
  );
}
